export default __webpack_public_path__ + "static/media/rnr-sports-table-26.7887eb23.webp";